import { useState, useEffect } from 'react';

const useExpiresTimer = expiresAt => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!expiresAt) {
      setRemaining(0);
      return;
    }

    const cleanExpiresAt = expiresAt.replace(/^0\s+/, '');

    // CRITICAL: Add 'Z' to parse as UTC since backend uses datetime.utcnow()
    const utcExpiresAt = cleanExpiresAt.endsWith('Z') ? cleanExpiresAt : cleanExpiresAt + 'Z';

    const expiry = new Date(utcExpiresAt).getTime();

    const updateRemaining = () => {
      const now = Date.now();
      const diff = expiry - now;
      const newRemaining = Math.max(0, diff);
      setRemaining(newRemaining);
    };

    updateRemaining();
    const interval = setInterval(updateRemaining, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [expiresAt]);

  return remaining;
};

export default useExpiresTimer;
